var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "phone"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29292",
    "data-name": "Rectangle 29292",
    width: 16,
    height: 16,
    transform: "translate(288 391)",
    fill: "#7e59d1",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_689",
    "data-name": "Mask Group 689",
    transform: "translate(-288 -391)",
    clipPath: "url(#phone)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-05-09T105620.050",
    "data-name": "svgexport-6 - 2022-05-09T105620.050",
    transform: "translate(288 391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11636",
    "data-name": "Group 11636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11635",
    "data-name": "Group 11635"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11662",
    "data-name": "Path 11662",
    d: "M15.565,11.742,13.332,9.51a1.485,1.485,0,0,0-2.472.558,1.52,1.52,0,0,1-1.754.957A6.885,6.885,0,0,1,4.958,6.878a1.445,1.445,0,0,1,.957-1.754,1.485,1.485,0,0,0,.558-2.472L4.241.419a1.593,1.593,0,0,0-2.153,0L.573,1.934C-.943,3.529.732,7.755,4.48,11.5s7.974,5.5,9.569,3.907L15.565,13.9A1.593,1.593,0,0,0,15.565,11.742Z",
    fill: "#7e59d1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.493ade82ab02ae0023048ab93a1b870c.svg";
export { ForwardRef as ReactComponent };